<template>
  <div class="menu">
    <div class="title">
      <img class="t_ai" src="./imgs/ai.png" alt="">
      <div class="t_text"  @click="chatTypeHandle({ chatType: null })">教师助手</div>
      <img  class="mlauto" v-show="showMenuLeft" src="@/assets/imgs/menu-splitG.png" alt="" @click="clickMenuSplit">
    </div>
    <div class="box">
      <div :class="['row', chatType == item.chatType ? 'select' : '']" @click="chatTypeHandle(item)"
        v-for="item in dataList" :key="item.chatType">
        <img :src="staticH + item.titleIcon" alt="" srcset="">
        <span>{{ item.title }}</span>
        <span v-if="item.tagIcon">
          <img style="width: 40px;height: 16px;margin-top: 6px;" :src="staticH + item.tagIcon" alt="">
        </span>
      </div>
      <el-popover placement="right" :width="230" style="height: 500px;">
        <template #reference>
          <div class="row rowp">
            <div class="rowp">
              <img src="./imgs/more.png" alt="" srcset="">
              <span>更多场景</span>
            </div>
            <el-icon color="#63849D" :size="20"><ArrowRight /></el-icon>
          </div>
        </template>
        <div class="popoverBox">
          <div class="popover" v-for="item in dataNewList">
            <div class="popover_title">{{ item.name }}</div>
            <div class="popover_row" v-for="i in item.subModules" @click="chatTypeHandle(i)">
              <img :src="staticH + i.titleIcon" alt="" srcset="">
              <span>{{ i.title }}</span>
            </div>
          </div>
        </div>
      </el-popover>
      <div class="row " @click="clickMine">
        <img src="@/assets/imgs/left-mine.png" alt="">
        <span>我的作品</span>
      </div>
      <div class="history">
        <div class="historyTitle">
          <div>历史对话</div>
          <div class="historyFlag" @click="goHistory"><img src="./imgs/history.png" alt=""></div>
        </div>
        <div class="historyRow" v-for="item in historyList" @click="jump(item)">{{ item.title }}</div>
      </div>
    </div>
    <div class="bottom">
      <!-- <div class="pay" @click="toRechargeHandle">
        <div class="bot_text">
          <div>AI豆购买&gt;</div>
          <div>购买畅快用</div>
        </div>
      </div> -->
      <template v-if="!memberCategoryId && intelligenceInfo.nikeName">
        <div class="member" v-if="pointLeft">
          <div class="member-left">
            <div>升级会员享更多权益</div>
            <div class="member-left-small">剩余 <span>{{ pointLeft }}</span> AI豆</div>
          </div>
          <div class="member-btn" @click="clickShowMember">去升级</div>
        </div>
        <img v-else class="free-noleft" src="@/assets/imgs/free-noleft.png" alt="" @click="clickShowMember">
      </template>

      <div class="person">
        <div class="person-left" @click="loginHandle">
          <img v-if="intelligenceInfo.url"  :src="`${files}/${intelligenceInfo.url}?key=${Math.random()}`"  style="border-radius: 100%;"
           alt="" srcset="">
          <img v-else style="border-radius: 100%;"
            :src="`${files}/el/uc/face/u${intelligenceInfo.id}.jpg?key=${Math.random()}`" alt="" srcset="">
          <div>
            <div class="pl-name">{{ intelligenceInfo?.nikeName || '去登录' }}</div>
            <div class="pl-member">
              <span v-if="!memberCategoryId">免费版</span>
              <span v-if="memberCategoryId == 2902 || memberCategoryId == 3074">Plus</span>
              <span v-if="memberCategoryId == 2904">Pro</span>
            </div>
          </div>
        </div>

        <el-dropdown >
          <!-- <el-icon v-show="intelligenceInfo.nikeName" color="#63849D" :size="20" style="cursor: pointer;position: relative;top: 1px;">
            <MoreFilled />
          </el-icon> -->
          <img class="curP" v-show="intelligenceInfo.nikeName" src="@/assets/imgs/more1.png" alt=""/>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item v-if="memberCategoryId" @click="clickShowMember">
                <div class="pi">
                  <div class="pi-left">
                    <div v-if="memberCategoryId == 2902 || memberCategoryId == 3074">升级PRO高级会员</div>
                    <div v-else>当前PRO高级会员</div>
                    <div class="pil-small" v-if="pointLeft">剩余 <span>{{ pointLeft }}</span> AI豆</div>
                  </div>
                  <div class="pi-btn" >
                    <span  v-if="memberCategoryId == 2902 || memberCategoryId == 3074">去升级</span>
                    <span v-else>去续费</span>
                  </div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item @click="wish">
                <img class="mr6" src="@/assets/imgs/suggest.png" alt="">
                意见反馈
              </el-dropdown-item>
              <el-dropdown-item @click="logoutM">
                <img class="mr6" src="@/assets/imgs/login-out.png" alt="">
                退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div class="dialog">
      <el-dialog v-model="dialogVisible" width="1000px" :close-on-click-modal="false" :close-on-press-escape="false"
        center>
        <template #title>
          <div class="switchTabs">
            <div :class="switchType == 1 ? 'ft600' : ''" style="margin-right:24px;cursor: pointer;"
              @click="switchTypeCall(1)">
              许愿功能
              <div v-if="switchType == 1" class="line"></div>
              <div v-else class="whiteLine"></div>
            </div>
            <div :class="switchType == 2 ? 'ft600' : ''" style="margin-left: 24px;cursor: pointer;"
              @click="switchTypeCall(2)">
              意见反馈
              <div v-if="switchType == 2" class="line"></div>
              <div v-else class="whiteLine"></div>
            </div>
          </div>
        </template>
        <div>
          <div class="dialog-title">
            <img src="../../assets/imgs/happy.png" />
            <div v-if="switchType == 1">许愿你想要的功能，呼声高的功能将会优先开放</div>
            <div v-if="switchType == 2">反馈内容（必填）</div>
          </div>
          <div v-if="switchType == 1">
            <el-input v-model="wishContent" :rows="8" maxlength="1000" type="textarea" placeholder="许愿您想要的任何其他功能～"
              resize="none" />
            <div class="count">{{ wishContent.length }}/1000</div>
          </div>
          <div v-if="switchType == 2">
            <el-input v-model="ideaContent" :rows="8" maxlength="1000" type="textarea"
              placeholder="请输入您对我们的意见或建议，我们会尽快处理。" resize="none" />
            <div class="count">{{ ideaContent.length }}/1000</div>
          </div>
        </div>
        <template #footer>
          <div class="dialog-footer">
            <div class="confirm" @click="confirm">提 交</div>
          </div>
        </template>
      </el-dialog>
    </div>

  </div>
</template>

<script setup>
import { ElMessage, ElMessageBox  } from 'element-plus';
import { menuList, addFeedback, menuNewList, getHistoryList, logout,
    getPointLeft, memberProductList, canBuyMember, memberNuonuoCreate, getMemberQrImg,
    memberDealNuonuoPayedOrder, cancelMemberOrder , myMemberStatus
} from '@/api/index';
import { ref, computed, watch, onMounted } from 'vue';
import { mittBus } from "@/utils/bus";
import { useStore } from "vuex";
import location from "@/utils/location";
import { useRoute, useRouter } from 'vue-router';
import dayjs from 'dayjs'
import useHomeStore from '@/store/home'
const homeStore = useHomeStore()
const store = useStore();
const router = useRouter();
const route = useRoute();
const staticH = location.static1();
const files = location.files1();
const dataList = ref([]);
const dataNewList = ref([]);
const historyList = ref([]);
const chatType = computed(() => store.state.chatType || sessionStorage.getItem('chatType'));
const isLock = computed(() => store.state.isLock);
const intelligenceInfo = ref(JSON.parse(localStorage.getItem('intelligenceInfo')) || {}) ;
const memberCategoryId = ref(1)
const latestValidEndTime = ref()
const userId = ref()


const showMenuLeft = ref(false)

mittBus.on("showMenuLeft", (val) => {
  showMenuLeft.value = val
});
//点击导航图片
const clickMenuSplit = () => {
   mittBus.emit('showMenu', false)
   mittBus.emit('showMenuRight', true)
}


const initMenuInfo = () => {
  const intelligenceData = localStorage.getItem('intelligenceInfo');
  if (intelligenceData) {
    intelligenceInfo.value = JSON.parse(intelligenceData) || {}
    memberCategoryId.value = intelligenceInfo.value?.memberCategoryId
    latestValidEndTime.value = intelligenceInfo.value?.latestValidEndTime
    userId.value = intelligenceInfo.value?.id
    getPointLeftM()
    getHistoryListM()
  }
}

let hasExecutedInit = false
let onMountedTimer = null

onMounted(() => {
  onMountedTimer = setTimeout(() => {
    if (!hasExecutedInit) {
      console.log('onMounted initMenuInfo1')
      initMenuInfo()
    }
  }, 1500)
})

mittBus.on('loginSuccess', () => {
  hasExecutedInit = true
  if (onMountedTimer) {
    clearTimeout(onMountedTimer)
    onMountedTimer = null
  }
  initMenuInfo()
});

const clickShowMember = () =>{
  console.log('clickShowMember', intelligenceInfo.value.memberCategoryId)
  if(!intelligenceInfo.value.memberCategoryId ) {
    //去开通
    mittBus.emit('showMember',1)
  }else {
    //去升级
    mittBus.emit('showMember',2)
  }
}



const loginHandle = () => {
  if (!intelligenceInfo.value?.nikeName) return homeStore.changeLogin();
};


const memberStatus = intelligenceInfo.value?.memberStatus //是否为会员（0=否，1=是）

const showMemberInsufficient = ref(false)
const myMemberData = ref({})
// 获取用户ID，用于生成localStorage的key



const myMemberStatusM = async () => {
  const memberInsufficientKey = `memberInsufficient_shown_${userId.value}`
  const res = await myMemberStatus()
  if(res.code == 200) {
    myMemberData.value = res.data
    if(res.data.memberInsufficient){
      // 检查localStorage中是否已经显示过该弹窗
      const hasShown = sessionStorage.getItem(memberInsufficientKey)
      console.log('hasShown', hasShown)
      if(!hasShown){
        showMemberInsufficient.value = true
        // 标记已显示过，避免再次弹出
        sessionStorage.setItem(memberInsufficientKey, 'true')
      }
    }
    console.log('')
  }
}


//点击续费弹窗按钮
const clickRenew = () => {
  if(memberCategoryId.value){
    showPro.value = true
  }
  showMemberInsufficient.value = false
  showMember.value = true

}

// 会员窗口
const showMember = ref(false)

mittBus.on("showMember", (val) => {
  console.log('val',val)
  if(val == 1) {
    showMember.value = true
  }else{
    showMember.value = true
    showPro.value = true
  }
});


const handleClose = () => {
  showMember.value = false
}

//点击tab
const showPro = ref(false)
const clickTab = (val) => {
  if (val == 1) {
    showPro.value = true
    plusOrProArrNow.value = proArr.value
  } else {
    showPro.value = false
    plusOrProArrNow.value = plusArr.value
  }
}
watch(showPro, (newVal) => {
  console.log('newVal', newVal)
  memberChecked.value = {}
})

const memberChecked = ref({}) //选中的会员
const plusArr = ref([])
const proArr = ref([])
const plusOrProArrNow = ref([])
//会员列表数据
const memberProductListM = async () => {
  const res = await memberProductList()
  if (res.code == 200) {
    plusArr.value = res.data.memberProductListDTOList.filter(item => item.memberCategoryId == 2902 )
    proArr.value = res.data.memberProductListDTOList.filter(item => item.memberCategoryId == 2904)
    plusOrProArrNow.value = plusArr.value
    console.log('plusArr', plusArr.value)
    console.log('xxx')
  }
}

//点击某个会员
const clickItem = (item) => {
  if(item.canBuy){
    memberChecked.value = item 
  }
}


//是否同意协议
const showAgree = ref(true)
//协议详情
const showAgreement = ref(false)
//显示同意协议
const showPayTips = ref(false)
//显示会员升级提示
const showUp = ref(false)

//显示规则
const showRule = ref(false)
const clickAgree = () => {
  showPayTips.value = false
  showAgree.value = true
}

//点击支付
const memberOrder = ref()
const loadingPay = ref(false)
const clickPay = async (up) => {
  console.log('clickPay', up)
  //是否同意协议
  if(!showAgree.value){
    showPayTips.value = true
    return 
  }
  //loading是不再调用
  if(loadingPay.value){
    return
  }
  
  loadingPay.value = true
  // await cancelMemberOrderM()
  canBuyMemberM()
}

const clickPayUp = () => {
  //是否同意协议
  if(!showAgree.value){
    showPayTips.value = true
    return 
  }
  // 升级会员
  showUp.value = true

}


const canBuyMemberM = async () => {
  const res = await canBuyMember()
  if(res.code == 200 && res.data) {
    console.log('memberChecked', memberChecked.value)
    const res = await memberNuonuoCreate({
      "amount": memberChecked.value.realAmount, //订单金额
      "note": undefined, //订单留言
      "payType": undefined, //订单类型，默认为微信，2922微信，2924支付宝，2928小程序支付
      "productSystemDictId": memberChecked.value.productSystemDictId, //会员商品字典id
      "type": 2 //设备类型，0苹果，1安卓，2诺诺
    })
    if(res.code == 200){
      memberOrder.value = res.data
      await getPayInfoM()
    }else{
      ElMessage.warning(res.message)
      loadingPay.value = false
    }
  }else{
    ElMessage.warning(res.message)
  }
}

const plusToPro = () => {
  showUp.value = false
  clickPay()
}



const qurl = ref() //二维码
let Time 
const getPayInfoM = async () =>{

  const res = await getMemberQrImg({
    orderNo: memberOrder.value
  })

  if(res.code == 200){
    qurl.value = res.data.qurl + `?timestamp=${new Date().getTime()}`
    showPay.value = true
    loadingPay.value = false
    console.log('res',res.data)
    Time = setInterval(() => {
      getOrderStatus();
    }, 1000);
  }else{
    ElMessageBox.alert(res.message, '警告', {
      confirmButtonText: '确定',
      callback: () => {
        router.back()
      },
    })

  }
  // loading.value = false
}

let isSuccess = ref(false);
const getOrderStatus = async() =>{
  const res  = await memberDealNuonuoPayedOrder({orderId:memberOrder.value })
  if(res.code == 200 &&  res.data.payedFlag == true){
    clearInterval(Time);
    isSuccess.value = true;
    ElMessage.success('操作成功')
    setTimeout(() => {
      window.location.reload()
    }, 1000);
  }
}

//显示支付二维码
const showPay = ref(false)

const cancelMemberOrderM = async () => {
  const res = await cancelMemberOrder({})
  if(res.code == 200){
    console.log('xx')
  }
}

watch(showPay, (val) => {
  if(!val && Time){
    clearInterval(Time);
  }
},{
  immediate: true
})



const clickPayBack = () => {
  showPay.value = false
}



//获取余额
const pointLeft = ref()
const getPointLeftM = async () => {
  const res = await getPointLeft()
  if (res.code == 200) {
    pointLeft.value = res.data.pointLeft
  }
}





watch(route, (val) => {
  getHistoryListM();
});

// 查询菜单数据
const menuListM = () => {
  menuList().then(res => {
    if (res.code == 200) {
      dataList.value = res.data;
    } else {
      ElMessage.error(res.msg);
    };
  });
};
menuListM();
// 新查询菜单数据
const menuNewListM = () => {
  menuNewList().then(res => {
    if (res.code == 200) {
      dataNewList.value = res.data.clazzModule;
      store.commit('changeMenu', res.data)
    } else {
      ElMessage.error(res.msg);
    };
  });
};
menuNewListM();
// 获取历史记录
const getHistoryListM = () => {
  getHistoryList({
    curPage: 1,
    pageSize: 10
  }).then((res) => {
    if (res.code == 200) {
      historyList.value = res.data;
    } else {
      ElMessage.error(res.message);
    }
  });
};

//点击我的教学设计
const clickMine = () => {
  if (!intelligenceInfo.value?.nikeName) return homeStore.changeLogin();
  if (isLock.value) return ElMessage.warning('对话进行中，请稍后再试');
  router.push('/mineworks')
}

// 切换
const chatTypeHandle = (val) => {
  if (!intelligenceInfo.value?.nikeName) return homeStore.changeLogin();
  if (isLock.value) return ElMessage.warning('对话进行中，请稍后再试');
  console.log('val', val)
  if(val.optionType == 2){
    store.commit('changeChatType', val.chatType);
    store.commit('changeUuid', true);
    router.push({
      path:'/writeHome',
      query:{
        t: Date.now()
      }
    })
    return
  }
  if (val.chatType == null) {
    store.commit('changeChatType', val.chatType);
    store.commit('changeUuid', false);
    router.push({
      path: '/home'
    });
  } else if (val.chatType == 18) {
    if (window.location.href.indexOf('/auth/chat/index.html') != -1) {
      window.open(window.location.origin + '/auth/chat/index.html#/composition');
    } else {
      window.open(window.location.origin + '/#/composition');
    }
  } else if (val.chatType == 4) {
    store.commit('changeChatType', val.chatType);
    store.commit('changeUuid', true);
    router.push({
      path:'/designHome'
    })
  }else if (val.chatType == 17 || val.chatType == 32) {
    store.commit('changeChatType', val.chatType);
    store.commit('changeUuid', true);
    router.push({
      path:'/pptHome'
    })
  }else if(val.chatType == 64){
    store.commit('changeChatType', val.chatType);
    store.commit('changeUuid', true);
    router.push({
      path:'/animationHome'
    })

  }else {
    store.commit('changeChatType', val.chatType);
    store.commit('changeUuid', true);
    router.push({
      path: '/chatRoom',
      query:{
        t: Date.now()
      }
    });
  };
};
// 支付
const toRechargeHandle = () => {
  if (!intelligenceInfo.value?.nikeName) return homeStore.changeLogin();
  if (isLock.value) return ElMessage.warning('对话进行中，请稍后再试');
  router.push('/recharge')
};
// 历史
const goHistory = ()=>{
  if (!intelligenceInfo.value?.nikeName) return homeStore.changeLogin();
  if (isLock.value) return ElMessage.warning('对话进行中，请稍后再试');
  router.push('/historyRecord')
}
const menu = computed(() => store.state.menu);
const jump = (item, e) => {
  if (isLock.value) return ElMessage.warning('对话进行中，请稍后再试');
  // if(item.taskId){
  //    window.open(`#/pptIframe?taskId=${item.taskId}`,'_blank')
  //    return
  // }
  store.commit("changeChatType", null);
  let sT = setTimeout(() => {
    store.commit("changeChatType", item.chatType);
    clearTimeout(sT);
  }, 1);
  store.commit("assignmentUuid", item.uuid);
  sessionStorage.setItem("uuid", item.uuid);

  console.log('', dataNewList.value)
  if(menu.value.find(i => i.chatType == item.chatType)?.optionType == 2) {
    router.push({
      path: "/writeChat",
      query: {
        uuid: item.uuid,
      },
    });
    return
  }
  
  if (item.chatType == 4 && item.pptFlag) {
    router.push({
      path: "/designPPT",
      query: {
        uuid: item.uuid,
        pptFlag: item.pptFlag,
        title: item.title
      },
    });
  } else if(item.chatType == 4) {
    router.push({
      path: "/designChat",
      query: {
        uuid: item.uuid,
      },
    });
  }else if(item.chatType == 17 || item.chatType == 32) {
    router.push({
      path: "/pptOutline",
      query: {
        uuid: item.uuid,
        title: item.title
      },
    });
  }else if(item.chatType == 64) {
    router.push({
      path: "/aniChat",
      query: {
        uuid: item.uuid,
        title: item.title
      },
    });
  }
   else {
    router.push({
      path: "/chatRoom",
      query: {
        uuid: item.uuid,
      },
    });
  }
};
// 许愿机
let wishContent = ref('')
let ideaContent = ref('')
let dialogVisible = ref(false)
let switchType = ref(1)
const wish = () => {
  if (isLock.value) return ElMessage.warning('对话进行中，请稍后再试');
  wishContent.value = ''
  ideaContent.value = ''
  switchType.value = 1
  dialogVisible.value = true
}
const switchTypeCall = (type) => {
  switchType.value = type
}
const confirm = () => {
  if (switchType.value == 1 && !wishContent.value.trim()) return ElMessage.warning('请输入许愿')
  if (switchType.value == 2 && !ideaContent.value.trim()) return ElMessage.warning('请输入意见')
  addFeedback({
    msg: switchType.value == 1 ? wishContent.value : ideaContent.value,
    type: switchType.value == 1 ? 1 : 0
  }).then(res => {
    if (res.code == 200) {
      ElMessage.success('提交成功')
      dialogVisible.value = false
    } else {
      ElMessage.error(res.message)
    }
  })
}
// 退出
const logoutM = () => {
  logout({
    info: localStorage.getItem('info')
  }).then(res => {
    if (res.code == 200) {
      // window.close();
      // router.go(0);
      router.push('/home');
      localStorage.clear();
    } else {
      router.push('/home');
    };
    setTimeout(() => {
      window.location.reload();
    }, 500);
  });
};
</script>

<style lang="scss" scoped>
.mlauto{
  margin-left: auto;
}
.mr8 {
  margin-right: 8px;
}
.mb16{
  margin-bottom: 16px;
}
.mb26{
  margin-bottom: 26px;
}
.ti2{
  text-indent: 2em; /* 缩进两个字符宽度 */
}
.curP{
  cursor: pointer;
}

.mr6 {
  margin-right: 6px;
}
.pm-header{
  background: url('@/assets/imgs/m-bg3.png') no-repeat;
  .pmh-center{
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 72px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #FFFFFF;
    font-weight: 400;
    .pmhc-left{
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .pmh-close{
      cursor: pointer;
    }
  }
  .pmh-size{
    height: 20px;
  }
}
.pm-center{
  display: flex;
  align-items: center;
  padding: 141px 205px 0 163px;
  .pmc-left{
    width: 280px;
    height: 344px;
    box-sizing: border-box;
    background: #F2F5F9;
    border-radius: 8px;
    margin-right: 64px;
    padding: 38px 33px 0 33px;
    text-align: center;
    .qurl-wrap{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 214px;
      height: 214px;
      background: #FFFFFF;
      border-radius: 8px;
      margin-bottom: 24px;
      .qurl{
        width: 210px;
        height: 210px;
      }
    }

  }
  .pmc-right{
    width: 328px;
    .pmr-top{
      display: flex;
      align-items: center;
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #191D20;
      font-weight: 600;
      padding-bottom: 24px;
      border-bottom: 1px solid #e8ecef;
      .avatar{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 8px;  
      }
    }
    .pmr-info{
      padding: 16px 0;
      border-bottom: 1px solid #e8ecef;
      margin-bottom: 32px;
      .pmr-line{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #191D20;
        font-weight: 400;
        width: 345px;
        .pmr-title{
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #6E7881;
          font-weight: 400;
        }
      }
    }
    .pmr-price{
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #191D20;
      font-weight: 600;
      .pmr-pricep{
        font-family: PingFangSC-Semibold;
        font-size: 28px;
        color: #FF6830;
        font-weight: 600;
      }
    }

  }
}

.tips-header{
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #191D20;
  font-weight: 600;
}
.payTips{
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #191D20;
  line-height: 22px;
  font-weight: 400;
  span{
    color: #1B84FF;
  }
}
.payUp{
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #191D20;
  line-height: 33px;
  font-weight: 400;
  .pu-price{
    font-family: PingFangSC-Semibold;
    font-size: 24px;
    color: #FF4000;
    line-height: 33px;
    font-weight: 600;
  }
  span{
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #FF4000;
    line-height: 33px;
    font-weight: 600;
  }
}
.pay-rule{
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #1B84FF;
  font-weight: 400;
  cursor: pointer;
}
.pd-rule{
  max-height: 500px;
  overflow: scroll;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #191D20;
  font-weight: 400;
}

.pi{
  width: 228px;
  height: 42px;
  box-sizing: border-box;
  padding: 8px 16px;
  background: #F8EED5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #64360D;
  font-weight: 500;
  .pi-left{
    padding: 5px 0;
    .pil-small{
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #64360D;
      font-weight: 400;
      span{
        color: #FF4000;
      }
    }
  }
  .pi-btn{
    width: 58px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #64360D;
    border-radius: 12px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FEE8BC;
    font-weight: 500;
  }
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  .edailog{
    width: 270px;
    height: 450px;
    background: url('@/assets/imgs/ex-plus.png') no-repeat;
    // background-color: pink;
    position: relative;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #191D20;
    text-align: center;
    line-height: 25px;
    font-weight: 400;
    &.pro{
      background: url('@/assets/imgs/ex-pro.png') no-repeat;
      .ed-content{
        .ed-btn{
          background: #1C1107;
          box-shadow: inset 0px 1px 9px 0px rgba(118,90,55,1);
          border-radius: 28px;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #F5D294;
          font-weight: 600;
        }
      }

    }
    .ed-close{
      position: absolute;
      right: -32px;
      top: 15px;
      cursor: pointer;
    }
    .ed-content{
      position: relative;
      top: 183px;
      span{
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #FF4000;
        line-height: 25px;
        font-weight: 600;
      }
      .ed-btn{
        margin: 0 auto;
        margin-top: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 204px;
        height: 40px;
        background: #2B58AE;
        box-shadow: inset 0px 1px 9px 0px rgba(255,255,255,0.5);
        border-radius: 28px;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #FFFFFF;
        font-weight: 600;
        cursor: pointer;
      }
    }

  }

  .mdialog {
    width: 1040px;
    height: 738px;
    border-radius: 16px;
    background-image: linear-gradient(180deg, #F5F7FB 0%, #FFFFFF 100%);

    .mdialog-header {
      background: url('@/assets/imgs/m-bg1.png') no-repeat;
      padding-bottom: 50px;

      &.pro {
        background: url('@/assets/imgs/m-bg2.png') no-repeat;
        .mh-top{
          .mt-left{
            .mt-name{
              font-family: PingFangSC-Semibold;
              font-size: 18px;
              color: #FFFFFF;
              font-weight: 600;
            }
            .mt-time{
              color: rgba(255, 255, 255, 0.60);
            }
          }
        }
        .mh-tab{
          .mb-tab1{
            font-size: 20px;
            color: rgba(255, 255, 255, 0.80);
          }
          .mb-tab2{
            font-size: 24px;
            color: #191D20;
          }
        }

      }

      .mh-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 24px 16px 16px;
        box-sizing: border-box;
        height: 72px;

        .mt-left {
          display: flex;
          align-items: center;
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #191D20;
          font-weight: 600;

          .avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 8px;
          }

          .mt-name {
            margin-right: 8px;
          }

          .mt-time {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: rgba(25, 29, 32, 0.60);
            font-weight: 400;
            .mt-plus{
              display: flex;
              align-items: center;
              img{
                width: 46px;
                height: 22px;
                margin-right: 6px;
              }
            }
          }
        }

        .mt-close {
          width: 16px;
          height: 16px;
          cursor: pointer;
        }

      }

      .mh-tab {
        height: 54px;
        line-height: 54px;
        display: flex;
        // align-items: center;

        .mb-tab1 {
          margin-right: 40px;
          flex: 1;
          cursor: pointer;
          font-family: AlimamaShuHeiTi-Bold;
          font-size: 24px;
          color: #191D20;
          text-align: center;
          font-weight: 700;
        }

        .mb-tab2 {
          flex: 1;
          cursor: pointer;
          font-family: AlimamaShuHeiTi-Bold;
          font-size: 20px;
          color: #374047;
          text-align: center;
          font-weight: 700;
        }
      }
    }

    .mdialog-center {
      display: flex;
      .mc-left {
        height: 560px;
        flex: 1;
        padding-left: 48px;
        padding-right: 48px;
        overflow: scroll;
        .m-list {
          margin-bottom: 40px;
          justify-content: space-evenly;
          display: flex;
          .m-item {
            text-align: center;
            width: 154px;
            height: 148px;
            box-sizing: border-box;
            padding-top: 13px;
            background: #FFFFFF;
            border-radius: 16px;
            overflow: hidden;
            cursor: pointer;
            &.checked{
              background-image: linear-gradient(180deg, #FFF4C4 0%, #FEFBE8 76%);
              border: 2px solid rgba(255,211,96,1);
              .m-name{
                color: #894400;
              }
              .m-price {
                color: #894400;
              }
              .m-save {
                background: #FFD360;
                color: #894400;
              }
              &.pro{
                background-image: linear-gradient(180deg, #FFDCC4 0%, #FFFFFF 76%);
                border: 2px solid rgba(253,83,25,1);
                .m-name{
                  color: #191D20;
                }
                .m-price {
                  color: #FD5319;
                }
                .m-save {
                  background: #FD5319;
                  color: #FFFFFF;
                }
              }
            }
            &.disabled{
              background: #EBEBEB;
              .m-save{
                background: rgba($color :#FFF3CC , $alpha: .7);
              }
            }

            .m-name {
              font-family: PingFangSC-Semibold;
              font-size: 18px;
              color: #191D20;
              font-weight: 600;
            }

            .m-price {
              font-family: PingFangSC-Semibold;
              font-size: 30px;
              color: #191D20;
              line-height: 42px;
              font-weight: 600;
              span{
                font-size: 24px;
              }
            }

            .m-price1 {
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #95AAB9;
              font-weight: 400;
              text-decoration: line-through;
            }

            .m-save {
              margin-top: 12px;
              background: #FFF3CC;
              height: 32px;
              line-height: 32px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #894400;
              font-weight: 400;
            }
          }
        }
        .m-compare{
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #191D20;
          font-weight: 600;
          .m-imgw{
            text-align: center;
          }
        }
      }

      .mc-right {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        width: 255px;
        height: 526px;
        border-left: 1px dashed #afb6c0;
        box-sizing: border-box;
        padding: 0px 24px;
        .mcr-top{
          .m-order{
            margin-bottom: 12px;
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #191D20;
            font-weight: 500;
          }
          .mr-checked{
            display: flex;
            justify-content: space-between;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #191D20;
            font-weight: 400;
            .mrc-price{
              font-family: PingFangSC-Semibold;
              font-size: 14px;
              color: #191D20;
              font-weight: 600;
            }
          }
        }
        .mcr-bottom{
          .mb-price{
            margin-bottom: 4px;
            font-family: PingFangSC-Semibold;
            font-size: 28px;
            color: #FF6830;
            font-weight: 600;
            span{
              text-decoration: line-through;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #95AAB9;
              font-weight: 400;
            }
          }
          .mb-btn{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 208px;
            height: 48px;
            background-image: linear-gradient(270deg, #FFD360 0%, #FFEB99 100%);
            border-radius: 8px;
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #894400;
            font-weight: 600;
            cursor: pointer;
            margin-bottom: 16px;
            &.type1{
              background: #EBEBEB;
              color: #ABBBCD;
            }
            &.pro{
              background-image: linear-gradient(270deg, #FF2323 9%, #FD8C19 100%);
              box-shadow: inset 0px 1px 9px 0px rgba(255,255,255,0.5);
              border-radius: 8px;
              color: #FFFFFF;
            }
          }
          .mb-agree{
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: PingFangSC-Regular;
            font-size: 13px;
            color: #6E7881;
            font-weight: 400;
            img{
              width: 14px;
              height: 14px;
              cursor: pointer;
            }
          }
        }

      }
    }

    .mdialog-footer {
      display: flex;
      gap: 10px;
      margin-top: 20px;
      justify-content: flex-end;
    }

  }
}




.menu {
  padding: 16px 16px 12px;
  background: #F5F7FB;
  height: 100%;
  box-sizing: border-box;
  width: 260px;
  position: relative;
  display: flex;
  flex-direction: column;

  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 24px;
    cursor: pointer;

    .t_ai {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }

    .t_text {
      font-family: AlimamaShuHeiTi-Bold;
      font-size: 22px;
      color: #191D20;
      letter-spacing: 0;
      font-weight: 700;
    }
  }

  .box {
    flex: 1;
    overflow-y: hidden;
    /* 默认隐藏垂直滚动条 */
    scrollbar-gutter: stable;
    /* 预留滚动条位置，避免内容挤压 */
    width: 244px;

    .row {
      width: 210px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 36px;
      margin: 4px 0px;
      cursor: pointer;
      padding-left: 12px;

      span {
        font-size: 14px;
        color: #191D20;
        letter-spacing: 0;
        font-weight: 400;
      }

      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .rowp {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .select {
      background: #E6F0FB;
      border-radius: 8px;
    }

    .row:hover {
      background: #E6F0FB;
      border-radius: 8px;
    }

    .history {
      .historyTitle {
        width: 210px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 36px;
        margin: 4px 0px;
        padding-left: 12px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #63849D;
        letter-spacing: 0;
        font-weight: 400;

        .historyFlag {
          width: 22px;
          height: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .historyFlag:hover {
          background: rgba(27, 132, 255, 0.08);
          border-radius: 8px;
        }
      }

      .historyRow {
        width: 210px;
        height: 36px;
        line-height: 36px;
        margin: 4px 0px;
        cursor: pointer;
        padding-left: 12px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #191D20;
        letter-spacing: 0;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .historyRow:hover {
        background: #E6F0FB;
        border-radius: 8px;
      }
    }
  }

  /* 鼠标移入时显示滚动条 */
  .box:hover {
    overflow-y: auto;
  }

  .bottom {
    .member {
      height: 53px;
      box-sizing: border-box;
      padding: 8px 12px 8px 16px;
      background: #F8EED5;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-image: linear-gradient(-29deg, #FEE8C1 0%, #FAE4BB 68%);
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #64360D;
      font-weight: 500;

      .member-left {
        .member-left-small {
          font-size: 12px;

          span {
            color: #ff4000;
          }
        }
      }

      .member-btn {
        width: 58px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #64360D;
        border-radius: 12px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #FEE8BC;
        font-weight: 500;
        cursor: pointer;
      }
    }
    .free-noleft{
      position: relative;
      left: -5px;
      cursor: pointer;
    }

    .pay {
      height: 95px;
      background: url('../../assets/imgs/recharge.png');
      position: relative;
      right: 10px;
      cursor: pointer;

      .bot_text {
        position: absolute;
        left: 45px;
        top: 30px;

        div:nth-child(1) {
          font-size: 16px;
          color: #3691FC;
          letter-spacing: 0;
          font-weight: 600;
        }

        div:nth-child(2) {
          font-size: 12px;
          color: #374047;
          letter-spacing: 0;
          text-align: center;
          font-weight: 400;
        }
      }
    }

    .person {
      width: 220px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      justify-content: space-between;
      width: 227px;
      height: 40px;
      box-sizing: border-box;
      padding: 4px 8px;

      .person-left {
        display: flex;
        align-items: center;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #191D20;
        letter-spacing: 0;
        font-weight: 600;
        cursor: pointer;
        img {
          width: 28px;
          height: 28px;
          margin-right: 8px;
          border-radius: 100%;
        }
        .pl-name{
          width: 150px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .pl-member {
          margin-top: 2px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #6E7881;
          line-height: 14px;
          font-weight: 400;
        }

      }

    }
    .person1 {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
}

.dialog {
  ::v-deep .el-dialog {
    border-radius: 24px;
    padding: 32px 50px;
  }

  .switchTabs {
    font-family: PingFangSC-Regular;
    font-size: 22px;
    color: #6E7881;
    letter-spacing: 0;
    font-weight: 400;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .ft600 {
      font-family: PingFangSC-Semibold;
      color: #191D20;
      font-weight: 600;
    }

    .line {
      margin: 0 auto;
      margin-top: 8px;
      background-image: linear-gradient(90deg, #3BE1F9 0%, #3363FF 44%, #9377FF 100%);
      border-radius: 3px;
      width: 48px;
      height: 6px;
    }

    .whiteLine {
      margin: 0 auto;
      margin-top: 8px;
      background: #fff;
      border-radius: 3px;
      width: 48px;
      height: 6px;
    }
  }

  .dialog-title {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #191D20;
    letter-spacing: 0;
    font-weight: 400;
    margin-bottom: 14px;
    display: flex;
    align-items: center;

    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }

  ::v-deep .el-textarea__inner {
    background: #F4F8FD;
    border-radius: 16px;
    padding: 12px 16px;
    font-size: 16px;
  }

  .count {
    margin-top: 7px;
    margin-right: 16px;
    text-align: right;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #A6B6C8;
    letter-spacing: 0;
    font-weight: 400;
  }

  ::v-deep .el-dialog__body {
    padding-bottom: 0;
  }

  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .confirm {
    background-image: linear-gradient(90deg, #3BE1F9 0%, #3363FF 44%, #9377FF 100%);
    border-radius: 8px;
    width: 136px;
    height: 40px;
    box-sizing: border-box;
    // padding: 10px 45px;
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 0;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.popoverBox {
  height: 70vh;
  overflow-y: hidden;
  /* 默认隐藏垂直滚动条 */
  scrollbar-gutter: stable;
  /* 预留滚动条位置，避免内容挤压 */
  width: 216px;
}

/* 鼠标移入时显示滚动条 */
.popoverBox:hover {
  overflow-y: auto;
}

.popover {
  .popover_title {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #63849D;
    letter-spacing: 0;
    font-weight: 400;
    height: 44px;
    line-height: 44px;
    padding-left: 16px;
  }

  .popover_row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 36px;
    margin: 4px 0px;
    cursor: pointer;

    span {
      font-size: 14px;
      color: #191D20;
      letter-spacing: 0;
      font-weight: 400;
    }

    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
      margin-left: 16px;
    }
  }

  .popover_row:hover {
    background: #E6F0FB;
    border-radius: 8px;
  }
}
</style>
